// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"136":"a3f4c4d2","499":"da8f6a83"}[chunkId] + ".chunk.js";
};